import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import {withRouter} from "../src/withRouter";
import {Card, Col, Container, ListGroup, Row} from "react-bootstrap";
import * as url from "url";
import {TwitterShareButton} from "react-share";

class ESHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            subscriptions: [],
            isSubscriptionsLoaded: false,
            games: [],
            isGamesLoaded: false,
            isLoaded: false,
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        userId: result.id
                    });

                    fetch(process.env.REACT_APP_API_URL + "/customer/" + result.id.toString() + "/subscriptions?limit=9&shuffle=true", {
                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                this.setState({
                                    isSubscriptionsLoaded: true,
                                    isGamesLoaded: true,
                                    subscriptions: result.subscriptions,
                                    games: result.games,
                                });
                            },

                            (error) => {
                                this.setState({
                                    isLoadedSubscriptions: true,
                                    error
                                });
                            }
                        )
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error: error,
                    });

                    fetch(`${process.env.REACT_APP_API_URL}/customer/game/recommendations`, {
                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                this.setState({
                                    isGamesLoaded: true,
                                    isSubscriptionsLoaded: false,
                                    games: result.games
                                });
                            },
                            // Note: it's important to handle errors here
                            // instead of a catch() block so that we don't swallow
                            // exceptions from actual bugs in components.
                            (error) => {
                                this.setState({
                                    isGamesLoaded: true,
                                    isSubscriptionsLoaded: false,
                                    error
                                });
                            }
                        )
                }
            );
    }

    shuffle(arr) {
        let array = arr;
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }

        return array;
    };

    render() {
        const { isSubscriptionsLoaded, subscriptions, games, isGamesLoaded, isLoaded } = this.state;
        let subscriptionsFormatted = [];
        let gamesFormatted = [];

        if (!isGamesLoaded) {
            gamesFormatted = <div>Loading...</div>;
        } else {
            let gamesShuffle = this.shuffle(games);

            gamesFormatted = <main style={{
                backgroundImage: `url("https://wallpapers.com/images/hd/cyberpunk-city-minimalist-0n0gr9gsk5at4b7h.jpg")`,
                width: "100%",
                marginBottom: "180%",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100%",
                color: "white",
                opacity: 0.8,
                fontWeight: "bold",
                height: 450,
            }}>

                <section className="py-5 text-center container">
                    <div className="row py-lg-5">
                        <div className="col-lg-6 col-md-8 mx-auto">
                            <h1 className="fw-light">Become publisher in 3 steps</h1>
                            <p className="lead text-body-secondary">Keep everything about your game in one place.
                                Multiple Operating Systems support, integration with other stores. Application-related
                                Social Media Network.</p>
                            <p>
                                <a href="/developer/console" className="btn btn-outline-light my-2">Developer Console</a>
                            </p>
                        </div>
                    </div>
                </section>

                <div className="album py-5 bg-body-tertiary">
                    <div className="container">

                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                            {gamesShuffle.map(item => (<div className="col">
                                <div className="card shadow-sm">
                                    <div className="bd-placeholder-img card-img-top" style={{
                                        width: "100%",
                                        height: "225px"
                                    }}>
                                        <img
                                            src={item.game_page ? item.game_page.background_image_url : "http://www.w3.org/2000/svg"}
                                            width="100%" height="100%"/>
                                    </div>
                                    <div className="card-body" style={{
                                        color: "darkgray"
                                    }}>
                                        <p className="card-text">{item.name}</p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-sm btn-outline-secondary">
                                                    <a style={{
                                                        textDecoration: "none",
                                                        color: "darkgray"
                                                    }} href={"/games/" + item.id.toString()}>Download</a>
                                                </button>
                                                <button type="button" className="btn btn-sm btn-outline-secondary">
                                                    <span
                                                    >
                                                    <TwitterShareButton
                                                        url={"https://easy-street.herokuapp.com/games/" + item.id.toString()}
                                                        quote={item.name}
                                                        hashtag="#easystreet"
                                                    >
                                                        Share
                                                    </TwitterShareButton>
                                                </span>
                                                </button>
                                            </div>
                                            <small
                                                className="text-body-secondary">
                                                {item.status !== 'active' ?
                                                    <span style={{
                                                        float: "right",
                                                        backgroundColor: "#ffea2b",
                                                        color: "#faf19d",
                                                        borderRadius: 5,
                                                        fontWeight: "bold",
                                                        capacity: 1,
                                                        paddingLeft: 5,
                                                        paddingRight: 5
                                                    }}>
                                            {item.status.replace('_', ' ').replace('_', ' ')}
                                        </span>
                                                    : item.genre.charAt(0).toUpperCase() + item.genre.slice(1)
                                                }
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>))}
                        </div>
                        <br/>
                        <div style={{
                            float: "right",
                            marginBottom: 0,
                            marginRight: 0,
                        }} className="col-sm">
                            <a href="/games" className="btn btn-primary">More</a>
                        </div>
                        <br/>
                        <hr/>
                        <br/>
                        <center>
                            <div style={{
                                backgroundImage: `url("https://wallpapercave.com/wp/wp5421495.jpg")`,
                                width: "150%",
                                marginLeft: "-25%",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100%",
                                color: "black",
                                fontWeight: "bold",
                                overflowX: "hidden",
                                background: `linear-gradient(rgba(55,55,55,0), rgba(55,55,55,1))`,
                                height: 350
                            }}>
                                <section className="py-3 text-center container">
                                    <div className="row py-lg-3">
                                        <div className="col-lg-6 col-md-8 mx-auto">
                                            <br/>
                                            <h1 className="fw-light">Explore with Easy Street</h1>
                                            <p className="lead text-body-secondary">Find your favourite publisher as easy as
                                            to find your favourite game!</p>
                                            <p>
                                                <a href="/publishers" className="btn btn-outline-dark my-2">Top publishers</a>
                                            </p>
                                        </div>
                                    </div>
                                </section>
                            </div>

                            <div style={{
                                marginTop: "10px"
                            }} className="row">
                                <div className="col">
                                    <div className="card shadow-sm">
                                        <svg className="bd-placeholder-img card-img-top" width="100%" height="225"
                                             xmlns="http://www.w3.org/2000/svg" role="img"
                                             aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice"
                                             focusable="false"><title>Most successful publisher</title>
                                            <rect width="100%" height="100%" fill="#55595c"></rect>
                                            <text x="50%" y="50%" fill="#eceeef" dy=".3em">Most successful publisher</text>
                                        </svg>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="btn-group">
                                                    <button type="button"
                                                            className="btn btn-sm btn-outline-secondary">
                                                        <a style={{
                                                            textDecoration: "none",
                                                            color: "darkgray"
                                                        }} href={"/publishers"}>View</a>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="card shadow-sm">
                                        <svg className="bd-placeholder-img card-img-top" width="100%" height="225"
                                             xmlns="http://www.w3.org/2000/svg" role="img"
                                             aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice"
                                             focusable="false"><title>Most popular category</title>
                                            <rect width="100%" height="100%" fill="#55595c"></rect>
                                            <text x="50%" y="50%" fill="#eceeef" dy=".3em">Most popular category</text>
                                        </svg>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="btn-group">
                                                    <button type="button"
                                                            className="btn btn-sm btn-outline-secondary">
                                                        <a style={{
                                                            textDecoration: "none",
                                                            color: "darkgray"
                                                        }} href={"/categories"}>View</a>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="card shadow-sm">
                                        <svg className="bd-placeholder-img card-img-top" width="100%" height="225"
                                             xmlns="http://www.w3.org/2000/svg" role="img"
                                             aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice"
                                             focusable="false"><title>Biggest genre</title>
                                            <rect width="100%" height="100%" fill="#55595c"></rect>
                                            <text x="50%" y="50%" fill="#eceeef" dy=".3em">Biggest genre</text>
                                        </svg>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="btn-group">
                                                    <button type="button"
                                                            className="btn btn-sm btn-outline-secondary">
                                                        <a style={{
                                                            textDecoration: "none",
                                                            color: "darkgray"
                                                        }} href={"/genres"}>View</a>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                            </div>
                            <br/>
                            <div style={{
                                backgroundImage: `url("https://wallpapercave.com/wp/wp10724331.jpg")`,
                                width: "150%",
                                marginLeft: "-25%",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100%",
                                marginBottom: 500,
                                color: "darkgray",
                                fontWeight: "bold",
                                overflowX: "hidden",
                                opacity: 1,
                                height: 550
                            }}>
                                <section className="py-3 text-center container">
                                    <div className="row py-lg-5">
                                        <div className="col-lg-6 col-md-8 mx-auto">
                                            <br/>
                                            <h1 className="fw-dark">Chat around your favourite apps!</h1>
                                            <p className="lead text-body-secondary">
                                                Collect all you need about everything you are interested in!
                                            </p>
                                            <p>
                                                <a href="/games" className="btn btn-outline-dark my-2">Start</a>
                                            </p>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </center>
                    </div>
                </div>

            </main>
        }
            return gamesFormatted

        /*<Container>
            <Row>
                <Col>
                    <br/>
                    <center><h3>Little pig, little pig! Let me in</h3></center>
                    <div class="row">
                        <div class="col-sm">
                            {gamesFormatted}
                        </div>
                        <div class="col-sm">
                            <div className="alert alert-success">
                                <h4>Most popular genre</h4>
                            </div>
                            <br/>
                            <div className="alert alert-success">
                                <h4>Most popular category</h4>
                            </div>
                            <br/>
                            <div className="alert alert-success">
                                <h4>Most successful publisher</h4>
                            </div>
                            <br/>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>*/
    }
}

export default withRouter(ESHome);
